import React, { useCallback, useContext, useEffect } from "react";
import "./Header.scss";
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { getIcon } from "../../utils/images";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../../utils/hooks";
import { getNotifications, logoutUser } from "../../services/user";
import Notification from "./Notification/Notification";
import UserContext from "../../context/UserContext";
import { message } from "antd";


const Header = (props) => {
  const navigate = useNavigate();
  const { data, loading: notificationLoading } = useFetch(useCallback(getNotifications, [props]))
  const { user, loading } = useContext(UserContext);

  if(!notificationLoading && !loading && !user){
    navigate('/')
  }

  const name = user?.name
  const company = user?.company
  const accountUrl = user?.account_url
  const logoutUrl = user?.logout_url
  const notifications = data?.notifications || []

  function redirectTo(e, path = '/shipment_management') {
    e.preventDefault();
    navigate(path);
  }

  async function handleLogout() {
    try {
      await logoutUser(logoutUrl)
    } catch (e) {
      message.error("Something went wrong!")
    } finally {
      navigate('/')
    }
  }

  return (
    <Navbar expand="xl" className="Header">
      <Navbar.Brand onClick={(e) => redirectTo(e, '/')} href="">
        <img className="logo" src={getIcon('header-logo')} alt="Logo" />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
        <Nav className="nav">
          <li className="nav-item">
            <a className="nav-item__link" href="/search_price">Search Price</a>
          </li>
          <li className="nav-item">
            <a className="nav-item__link" href="/#FAQs">FAQs</a>
          </li>
          {/* <li className="nav-item">
            <a className="nav-item__link" href="" onClick={(e) => redirectTo(e, '/contact_us')}>Contact Us</a>
          </li> */}
          <li className="nav-item nav-divider"></li>
          <li className="nav-item">
            <a className="nav-item__link" href="" onClick={(e) => redirectTo(e, '/shipment_management')}>My Shipments</a>
          </li>
          {/* <button className="nav-item__btn btn btn-default" href=""><ReactSVG src={getIcon('chat')} /></button> */}

          <Notification notifications={notifications}>
            <button className="nav-item__btn btn btn-default" href="">
              <ReactSVG src={getIcon('bell-lg')} />
            </button>
          </Notification>

          <NavDropdown
            title={
              (
                <div className="dropdown">
                  <div className="dropdown__title">{name}</div>
                  <div className="dropdown__subtitle">{company}</div>
                </div>
              )
            }
            id="basic-nav-dropdown"
          >
            <NavDropdown.Item href={accountUrl}>Account</NavDropdown.Item>
            <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Header;
